import { Injectable } from "@angular/core";
import { IOrderRecapService, CHANNEL_RECAP_SERVICE } from "../IOrderRecapService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { OrderRecapAdapter } from "../adapter/OrderRecapAdapter";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderRecapPrimaryService implements IOrderRecapService {
  protected broker: ServiceMessageBroker;

  constructor(
    private worker: CubiqWorker,
    protected factory: ServiceMessageBrokerFactory,
    private orderRecapAdapter: OrderRecapAdapter,
  ) {
    this.broker = this.factory.createMessageBroker(CHANNEL_RECAP_SERVICE, true, true);
    this.broker.registerMethod(
      "getOrderRecap",
      [PRIMITIVE],
      this.getOrderRecap.bind(this),
      PRIMITIVE,
    );
  }

  public getOrderRecap(orderIds: any): Promise<Array<string>> {
    let request: CubiqTS.OrderRecapLookupRequestImpl = new CubiqTS.OrderRecapLookupRequestImpl();

    request.orderIds = orderIds;
    request.protocol = CubiqTS.Protocol.RFQ;

    return new Promise<Array<string>>((resolve, reject) => {
      this.worker.postServiceRequest(request).then(
        (event: CubiqTS.StandardReportImpl) => {
          if (event instanceof CubiqTS.StandardReportImpl && Array.isArray(event.results)) {
            resolve(event.results);
          } else {
            // a server error
            reject(event);
          }
        },
        (error: any) => {
          reject(error);
        },
      );
    });
  }
}
